<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li
            v-if="
              field !== 'paymentsName' ||
              orderType !== 2 ||
              !orderType || 
             (orderType === 2 && !ordersNum)
            "
          >
            <vxe-radio name="xtabs" label="tab2">选择用户银行账户</vxe-radio>
          </li>
          <li
            v-if="
              (field == 'paymentsName' && orderType == 2) ||
              (field == 'paymentsName' && !orderType)
            "
          >
            <vxe-radio name="xtabs" label="tab1">选择平台银行账户</vxe-radio>
          </li>
          
        </ul>
      </vxe-radio-group>
      <div class="account-search-box">
        <vxe-input
          style="height: 34px !important"
          v-model="searchKey"
          type="search"
          placeholder="搜索"
          @keyup.enter.native="search"
          @search-click="search"
        ></vxe-input>
      </div>
      <div class="close" @click="close">
        <i class="vxe-icon--close"></i>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
        show-overflow
        highlight-hover-row
        stripe
        border="none"
        ref="xTable"
        class="table-style"
        align="center"
        :auto-resize="true"
        :data="platTableData"
        max-height="480"
        @cell-click="cellClick"
      >
        <vxe-table-column
          field="companyName"
          title="企业名称"
        ></vxe-table-column>
        <vxe-table-column field="accountName" title="户名"></vxe-table-column>
        <vxe-table-column field="bankName" title="开户行"></vxe-table-column>
        <vxe-table-column field="accountNum" title="账户号"></vxe-table-column>
        <vxe-table-column field="bankAccountType" title="账户类型">
          <template v-slot="{ row }">
            <div>{{ row.bankAccountType | bankAccountType }}</div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <!-- <vxe-pager
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="getBankAccountList"
        v-if="!isShow || type === 0"
      ></vxe-pager> -->
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
        show-overflow
        highlight-hover-row
        stripe
        border="none"
        ref="xTable2"
        class="table-style"
        align="center"
        :auto-resize="true"
        :data="userTableData"
        max-height="450"
        @cell-click="cellClick"
      >
        <vxe-table-column field="accountName" title="户名"></vxe-table-column>
        <vxe-table-column field="openBankName" title="开户行"></vxe-table-column>
        <vxe-table-column field="accountNum" title="账户号"></vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="getBankAccountList"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import { apiRequest } from "@/utils/api";
const empties = [undefined, "", null, "null", {}, []];

export default {
  name: "BankAccount",
  data() {
    return {
      selectTab: "tab1",
      searchKey: "",
      type: 1,
      accountCate: "",
      accountName: "",
      title: "",
      platTableData: [],
      userTableData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      index: null,
      field: "",
      obj: null,
      orderType: null,
      isShow: false,
      ordersNum: null,
    };
  },
  watch: {
    field: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == "paymentsName") {
          if (this.orderType === 2 && this.ordersNum) {
            this.selectTab = "tab1";
          } else {
            this.selectTab = "tab2";
          }
        } else {
          // debugger
          this.selectTab = "tab2";
        }
      },
    },
  },
  filters: {
    bankAccountType(val) {
      if (val != null) {
        if (val === 1) {
          return "现金账户"
        }
        if (val === 2) {
          return "银行账户（一般户）"
        }
        if (val === 3) {
          return "银行账户（基本户）"
        }
        if (val === 4) {
          return "汇票账户"
        }
      }
    }
  },
  mounted() {
    // this.getBankAccountList();
    this.initPlatData();
    this.initUserData();
  },
  methods: {
    init(type, index, field, obj) {
      this.type = type;
      this.index = index;
      this.field = field;
      this.obj = obj;
      this.orderType = obj ? obj.paymentType : null;
      this.ordersNum = obj ? obj.ordersNum : null;
      console.log(obj);

      //   console.log(obj, "ooooooooo");
      //   this.platformCompanyId = platformCompanyId;
      //   this.clientId = clientId;
      //   this.subjectId = subjectId;
      //  this.accountCate = accountCate;
      //   this.paymentType = paymentType;
      //   this.title =
      // if (this.type === 1) {
      //   // 线下支付
      //   if (this.orderType == 2) {
      //     this.title =
      //       this.field == "paymentsName"
      //         ? "选择平台银行账户"
      //         : "选择用户银行账户";
      //   } else {
      //     this.title = "选择用户银行账户";
      //   }
      // }
      //   accountCate == "platform" ? "选择平台银行账户" : "选择用户银行账户";
      this.page.currentPage = 1;
      this.searchKey = "";
      this.selectTab = "tab1";
      // if (!empties.includes(this.ordersNum)) {
      //   this.getBankAccountList();
      // } else {
      //   this.initPlatData();
      //   this.initUserData();
      // }
    },
    // search(word) {
    //   this.page.currentPage = 1;
    //   this.accountName = word;
    //   this.getBankAccountList(false);
    // },
    search() {
      if (this.selectTab === "tab1") {
        // 搜索企业用户列表
        this.initPlatData();
      } else {
        this.page.currentPage = 1;
        this.page.pageSize = 10;
        this.initUserData();
      }
    },
    async initPlatData() {
      let params = {
        page: 1,
        rows: 10000,
        userType: 0,
      };
      params.accountName = this.searchKey;
      let res = await apiRequest(
        "api/order/",
        "platform_corp/getPlatformCompanyList",
        params
      );
      this.platTableData = res.data;
    },
    async initUserData() {
      let params = {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        userType: 0,
      };
      params.accountName = this.searchKey;
      let res = await apiRequest(
        "api/auth/",
        "baseUserSign/queryUserBankList",
        params
      );
      this.userTableData = res.data.rows;
      this.page.totalResult = res.data.total;
    },
    async getBankAccountList(isBySearch = true) {
      // 线下支付
      if (this.type === 1) {
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          userType: 0,
        };
        if (!empties.includes(this.accountName)) {
          params.accountName = this.accountName;
        }
        let res;
        if (this.field == "paymentsName" && this.orderType === 2) {
          this.selectTab = "tab1";
          if (isBySearch) {
            params.companyName = this.obj.buyerName;
          }

          res = await apiRequest(
            "api/order/",
            "platform_corp/getPlatformCompanyList",
            params
          );
          this.isShow = true;
          this.platTableData = res.data;
        } else {
          this.selectTab = "tab2";
          // if (this.field == "paymentsName") {
          //   // 实际承运人订单 付款企业
          //   // console.log(this.obj, 'this.obj');
          //   if (isBySearch) {
          //     params.userId = this.obj ? this.obj.buyerId : "";
          //   }
          // } else {
          //   if (isBySearch) {
          //     params.userId = this.obj ? this.obj.sellerId : "";
          //   }
          // }
          res = await apiRequest(
            "api/auth/",
            "baseUserSign/queryUserBankList",
            params
          );
          this.isShow = false;
          this.userTableData = res.data.rows;
          this.page.totalResult = res.data.total;
        }

        // if (this.orderType === 2) {
        //   // 线下支付承运人订单
        //   if (this.field == "paymentsName") {
        //     params.companyName = this.obj.buyerName;
        //     res = await apiRequest(
        //       "api/order/",
        //       "platform_corp/getPlatformCompanyList",
        //       params
        //     );
        //     this.isShow = true;
        //     this.tableData = res.data;
        //   } else {
        //     params.userId = this.obj.sellerId ;
        //     res = await apiRequest(
        //       "api/auth/",
        //       "baseUserSign/queryUserBankList",
        //       params
        //     );
        //     this.isShow = false;
        //     this.tableData = res.data.rows;
        //     this.page.totalResult = res.data.total;
        //   }
        // } else {
        //   // 线下支付实际承运人订单
        //   res = await apiRequest(
        //     "api/auth/",
        //     "baseUserSign/queryUserBankList",
        //     params
        //   );
        //   this.isShow = false;
        //   this.tableData = res.data.rows;
        //   this.page.totalResult = res.data.total;
        // }
      } else {
        // 线上支付
        let params = {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          orderBy: 2,
        };
        let path = "api/finance/";
        let action = "cebBusiMem/queryMemList";

        let res;
        params.busiSubjectId = this.obj.platformCompanyId;

        if (this.field == "paymentsName") {
          // 付款人参数

          params.subjectId = this.obj.buyerId;
          switch (this.orderType) {
            case 1:
              params.subjectType = 1;
              break;
            case 2:
              params.subjectType = 0;
              break;
            case 3:
              params.subjectType = 1;
          }
        } else {
          // 收款人参数
          params.subjectId = this.obj.sellerId;
          switch (this.orderType) {
            case 1:
              params.subjectType = 0;
              break;
            case 2:
              params.subjectType = 1;
              break;
            case 3:
              params.subjectType = 1;
          }
        }

        res = await apiRequest(path, action, params);
        let dataRows = res.data.rows;
        dataRows = dataRows.map((item) => {
          console.log(item, "aaaaaa");
          return {
            accountName: item.bindAccName,
            accountNum: item.bindAccNum,
            bankName: item.bindOpenBankName,
          };
        });
        this.tableData = dataRows;
        this.page.totalResult = res.data.total;
      }

      // console.log(this.tableData);
    },
    cellClick({ row }) {
      let curRow = Object.assign(row, {
        rowType: this.selectTab == "tab2" ? "user" : "plat"
      })
      this.$emit("choose", curRow, this.index);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.account-search-box {
  position: absolute;
  right: 50px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}
.close {
  position: absolute;
  right: 10px;
  top: 15px;
}
</style>